var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnknownCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02148 12.4478V11.9058C9.02148 11.437 9.12158 11.0293 9.32178 10.6826C9.52197 10.3359 9.88818 9.96729 10.4204 9.57666C10.9331 9.21045 11.27 8.9126 11.4312 8.68311C11.5972 8.45361 11.6802 8.19727 11.6802 7.91406C11.6802 7.59668 11.563 7.35498 11.3286 7.18896C11.0942 7.02295 10.7671 6.93994 10.3472 6.93994C9.61475 6.93994 8.77979 7.1792 7.84229 7.65771L7.04395 6.05371C8.13281 5.44336 9.2876 5.13818 10.5083 5.13818C11.5142 5.13818 12.3125 5.37988 12.9033 5.86328C13.499 6.34668 13.7969 6.99121 13.7969 7.79688C13.7969 8.33398 13.6748 8.79785 13.4307 9.18848C13.1865 9.5791 12.7227 10.0186 12.0391 10.5068C11.5703 10.8535 11.2725 11.1172 11.1455 11.2979C11.0234 11.4785 10.9624 11.7153 10.9624 12.0083V12.4478H9.02148ZM8.78711 14.9526C8.78711 14.5425 8.89697 14.2324 9.1167 14.0225C9.33643 13.8125 9.65625 13.7075 10.0762 13.7075C10.4814 13.7075 10.7939 13.8149 11.0137 14.0298C11.2383 14.2446 11.3506 14.5522 11.3506 14.9526C11.3506 15.3384 11.2383 15.6436 11.0137 15.8682C10.7891 16.0879 10.4766 16.1978 10.0762 16.1978C9.66602 16.1978 9.34863 16.0903 9.12402 15.8755C8.89941 15.6558 8.78711 15.3481 8.78711 14.9526Z",
    fill: "#C40F11"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownCode);
export default __webpack_public_path__ + "static/media/unknown-code.79ee0020124064b4c5aa42683af62bed.svg";
export { ForwardRef as ReactComponent };